import { Editor, Node, Path, Point, Range, Transforms } from 'slate';

function touchesHeader(editor, selection) {
  for (const [node, path] of Node.descendants(editor)) {
    if (node.type === 'site-nav' && Range.intersection(selection, Editor.range(editor, path))) {
      return true;
    }
  }
  return false;
}

export function deleteSelection(editor) {
  const selection = editor.selection;
  if (!selection || Range.isCollapsed(selection)) {
    return false;
  }
  if (!touchesHeader(editor, selection)) {
    return false;
  }
  const start = Range.start(selection);
  const end = Range.end(selection);
  const reference = Editor.pointRef(editor, start, { affinity: 'backward' });
  const texts = [];
  const items = [];
  for (const [node, absolute] of Node.descendants(editor)) {
    if (typeof node.text === 'string') {
      const range = { anchor: { path: absolute, offset: 0 }, focus: { path: absolute, offset: node.text.length } };
      const intersection = Range.intersection(selection, range);
      if (intersection && !Range.isCollapsed(intersection)) {
        texts.push(intersection);
      }
    } else if (node.type === 'site-nav' || node.type === 'site-nav-item') {
      const range = Editor.range(editor, absolute);
      if (Point.compare(start, Range.start(range)) <= 0 && Point.compare(end, Range.end(range)) >= 0) {
        let descendant = false;
        for (const item of items) {
          descendant = descendant || Path.isAncestor(item, absolute);
        }
        if (!descendant) {
          items.push(absolute);
        }
      }
    }
  }
  Editor.withoutNormalizing(editor, function removeSelection() {
    for (let index = texts.length - 1; index >= 0; index--) {
      Transforms.delete(editor, { at: texts[index] });
    }
    for (let index = items.length - 1; index >= 0; index--) {
      Transforms.removeNodes(editor, { at: items[index] });
    }
    const point = reference.unref();
    if (point) {
      Transforms.select(editor, point);
    } else {
      Transforms.select(editor, Editor.start(editor, []));
    }
  });
  return true;
}
